<template>
    <div class="admin-smartwatch-page">
        <button-component
                class="new-smartwatch-button"
                @click.native="addNewSmartwatch()">
            Smartwatch toevoegen
        </button-component>
        <ul>
            <listitem-component
                    v-for="smartwatch in getAllSmartwatches"
                    :key="smartwatch.id"
                    @click.native="editSmartwatch(smartwatch)">
                {{ smartwatch.smartwatchName }}
            </listitem-component>
            <p v-if="getAllSmartwatches.length < 1">Er zijn nog geen smartwatches toegevoegd</p>
        </ul>
    </div>
</template>

<script>
import { Viewport } from '../../utils/enums';
import { RouteName } from '../../utils/enums';
import ListitemComponent from '../../components/listitem.component';
import ButtonComponent from '../../components/button.component.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'admin-smartwatch-page',
    components: {
        ListitemComponent,
        ButtonComponent
    },
    computed: {
        ...mapGetters(['getAllSmartwatches']),
    },
    created() {
        this.$store.dispatch('FETCH_ALL_SMARTWATCHES');
    },
    methods: {
        addNewSmartwatch() {
            this.$router.push({ name: RouteName.ADMIN_NEW_SMARTWATCH });
        },
        editSmartwatch(smartwatch) {
            this.$store.commit('SET_SMARTWATCH_TO_EDIT', smartwatch);
            this.$router.push({ name: RouteName.ADMIN_EDIT_SMARTWATCH });
        }
    }
};
</script>

<style scoped lang="scss">
    .listitem-component::v-deep {
        .listitem-icon {
            background-image: url('../../assets/icons/watch-large-white.svg');
            background-position-y: 12px;
        }
    }
    .new-smartwatch-button {
        margin-bottom: 1rem;
    }
</style>
